import { Edition } from '@atlassian/touchpoint-commons-event-analytics';

import type { DialogConfig } from '../shared/types';

export const FREE_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'startTrial',
	dialogId: 'automation-free-limit-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.STANDARD_EDITION,
};

export const STANDARD_DIALOG_CONFIG: DialogConfig = {
	touchpointIntent: 'addPaymentDetails',
	dialogId: 'automation-free-limit-modal',
	dialogType: 'modal',
	targetProductEdition: Edition.STANDARD_EDITION,
};
